import React, { Component } from 'react';
import { connect } from 'react-redux';
import Calendar from 'lib/Calendar';
import has from 'lodash/has';

class EventBubble extends Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  bubble(time_range_start_timestamp, time_range_end_timestamp, pixel_per_minute, num_event, event_class, name, date_start, date_end, time_start, time_end, time_setup, time_breakdown, objects, custom_offset, custom_width) {

      if(typeof objects == 'undefined') var objects = null;
      if(typeof custom_offset == 'undefined') var custom_offset = null;
      if(typeof custom_width == 'undefined') var custom_width = null;

      var event_bubble_style = {};

      if(custom_offset != null) {
        var left = (86 + ((num_event - 1) * custom_offset)) + 'px';
      }
      else {
        var left = (86 + ((num_event - 1) * 197)) + 'px';
      }

      if(custom_width != null) {
        event_bubble_style.width = custom_width + 'px';
      }

      var start_timestamp = Calendar.getTimeTimestamp(time_start, date_start);
      var end_timestamp = Calendar.getTimeTimestamp(time_end, date_end);

      var setup_ok = false;
      var breakdown_ok = false;

      if(time_setup.length > 0) {
        if(start_timestamp > time_range_start_timestamp) {
          var setup_timestamp = Calendar.getTimeTimestamp(time_setup, date_start);

          var setup_class = '';

          if(setup_timestamp < time_range_start_timestamp) {
            setup_timestamp = time_range_start_timestamp;
            setup_class = ' cut_top';
          }

          var time_setup_minutes = ((setup_timestamp - time_range_start_timestamp) / 60000);

          setup_ok = true;
        }
      }

      var main_class = '';

      if(start_timestamp < time_range_start_timestamp) {
        start_timestamp = time_range_start_timestamp;
        main_class = ' cut_top';
      }

      var time_start_minutes = ((start_timestamp - time_range_start_timestamp) / 60000);

      if(time_breakdown.length > 0) {
        if(end_timestamp < time_range_end_timestamp) {
          var breakdown_timestamp = Calendar.getTimeTimestamp(time_breakdown, date_end);

          var breakdown_class = '';

          if(breakdown_timestamp > time_range_end_timestamp) {
            breakdown_timestamp = time_range_end_timestamp;
            breakdown_class = ' cut_bottom';
          }

          var time_breakdown_minutes = ((breakdown_timestamp - time_range_start_timestamp) / 60000);

          breakdown_ok = true;
        }
      }
      
      if(end_timestamp > time_range_end_timestamp) {
        end_timestamp = time_range_end_timestamp;
        main_class += ' cut_bottom';
      }

      var time_end_minutes = ((end_timestamp - time_range_start_timestamp) / 60000);

      if(setup_ok) {
        var time_setup_elapsed_minutes = time_start_minutes - time_setup_minutes;

        var top = Math.floor((time_setup_minutes * pixel_per_minute));
        var setup_height = Math.ceil((time_setup_elapsed_minutes * pixel_per_minute) - 8);

        var padding = 8;

        if(setup_height < 0) {
          padding += setup_height;
          setup_height = 0;
        }

        if(setup_height < 14 && padding > 0) {

          if((setup_height + padding) > 14) {

            padding -= (14 - setup_height);
            setup_height = 14;
          }
          else {

            setup_height += padding;
            padding = 0;
          }
        }

        padding = padding / 2;

        if(setup_height == 0 && padding == 0) setup_height = 1;

        var event_bubble_event_time_setup_style = {
          top: top + 'px',
          left: left,
          height: setup_height + 'px',
          paddingTop: padding + 'px',
          paddingBottom: padding + 'px',
        };

        if(custom_width != null) {
          event_bubble_event_time_setup_style.width = custom_width + 'px';
        }
      }

      var time_start_elapsed_minutes = time_end_minutes - time_start_minutes;

      var top = Math.floor((time_start_minutes * pixel_per_minute));
      var height = Math.ceil((time_start_elapsed_minutes * pixel_per_minute) - 24);

      var padding = 24;

      if(height < 0) {
        padding += height;
        height = 0;
      }

      if(height < 14 && padding > 0) {

        if((height + padding) > 14) {

          padding -= (14 - height);
          height = 14;
        }
        else {
          
          height += padding;
          padding = 0;
        }
      }

      padding = padding / 2;

      if(!breakdown_ok) height += 1;

      if(height == 0 && padding == 0) height = 1;

      var event_bubble_main_style = {
        top: top + 'px',
        left: left,
        height: height + 'px',
        paddingTop: padding + 'px',
        paddingBottom: padding + 'px',
      };

      if(custom_width != null) {
        event_bubble_main_style.width = custom_width + 'px';
      }

      if(breakdown_ok) {
        var time_breakdown_elapsed_minutes = time_breakdown_minutes - time_end_minutes;

        var top = Math.floor((time_end_minutes * pixel_per_minute));
        var breakdown_height = Math.ceil((time_breakdown_elapsed_minutes * pixel_per_minute) - 8) + 1;

        var padding = 8;

        if(breakdown_height < 0) {
          padding += breakdown_height;
          breakdown_height = 0;
        }

        if(breakdown_height < 14 && padding > 0) {

          if((breakdown_height + padding) > 14) {

            padding -= (14 - breakdown_height);
            breakdown_height = 14;
          }
          else {
            
            breakdown_height += padding;
            padding = 0;
          }
        }

        padding = padding / 2;

        if(breakdown_height == 0 && padding == 0) breakdown_height = 1;

        var event_bubble_event_time_breakdown_style = {
          top: top + 'px',
          left: left,
          height: breakdown_height + 'px',
          paddingTop: padding + 'px',
          paddingBottom: padding + 'px',
        };

        if(custom_width != null) {
          event_bubble_event_time_breakdown_style.width = custom_width + 'px';
        }
      }

      if(name.length < 1) name = 'Event Name';

      let setup_out;
      let objects_out;
      let breakdown_out;

      if(setup_ok) {
        if(setup_height >= 14) var setup_text = 'Setup';
        else var setup_text = '\u00a0';

        setup_out = <div key={`event_bubble_${date_start}_event_${num_event}_setup`} className={`time_setup ${setup_class}`} style={event_bubble_event_time_setup_style}>{setup_text}</div>;
      }

      if(objects != null) {

        let objects_divs = [];

        for(let i in objects)
        {
          objects_divs.push( <div key={`event_bubble_${date_start}_event_${num_event}_object_${i}`} className="object" dangerouslySetInnerHTML={{ __html: objects[i] }} /> );
        }
        
        objects_out = <div key={`event_bubble_${date_start}_event_${num_event}_objects`} className="objects">{objects_divs}</div>;
      }

      if(breakdown_ok) {
        if(breakdown_height >= 14) var breakdown_text = 'Breakdown';
        else var breakdown_text = '\u00a0';

        breakdown_out = <div key={`event_bubble_${date_start}_event_${num_event}_breakdown`} className={`time_setup ${breakdown_class}`} style={event_bubble_event_time_breakdown_style}>{breakdown_text}</div>;
      }

      return (
        <div key={`event_bubble_${date_start}_event_${num_event}`} className={`event ${event_class}`} style={event_bubble_style}>
          {setup_out}
          <div key={`event_bubble_${date_start}_event_${num_event}_main`} className={`main ${main_class}`} style={event_bubble_main_style}>
            <div key={`event_bubble_${date_start}_event_${num_event}_name`} className="name" dangerouslySetInnerHTML={{ __html: name }} />
            {objects_out}
          </div>
          {breakdown_out}
        </div>
      );
  }

  render() {
    const { isLoaded, event, conflicts } = this.props;

    if (!isLoaded) {
      return null;
    }

    var error_msg = "";
    var error_msg_length = 0;

    var name = event.name;

    if(name.length == 0) {
      name = "Event Name";
    }

    var date_start = event.date_start;
    var date_end = event.date_end;

    if(date_end == null) date_end = '';
    
    var date_start_timestamp = -1;
    var date_end_timestamp = -1;
    
    if(date_start.length > 0) {
      date_start_timestamp = Calendar.getDateTimestamp(date_start);
      
      if(isNaN(date_start_timestamp)) error_msg += "Enter a valid Start Date<br />";
    }
    else if(!template) {
      error_msg += "Please enter a Start Date<br />";
    }
    
    if(date_end.length > 0)
    {
      date_end_timestamp = Calendar.getDateTimestamp(date_end);
      
      if(isNaN(date_end_timestamp)) {
        error_msg += "Enter a valid End Date<br />";
      }
      else if(!isNaN(date_start_timestamp) && date_start_timestamp != -1) {

        if(date_end_timestamp < date_start_timestamp) {
          error_msg += "The Start Date must be before the End Date<br />";
        }
        else {
          //86400000 = # of milliseconds in 1 day
          var date_diff = (date_end_timestamp - date_start_timestamp) / (86400000);
          
          if(date_diff > 60) error_msg += "Your event cannot span more than 60 days continuously";
        }
      }
      else if(template) {
        error_msg += "You must select a Start Date if you have selected an End Date";
      }
    }
    else
    {
      date_end = date_start;
      date_end_timestamp = date_start_timestamp;
    }
    
    if(error_msg.length > 0 && error_msg.length > error_msg_length) {
      error_msg_length = error_msg.length;
    }

    var time_start = event.time_start;
    var time_end = event.time_end;

    var tbd_start = event.tbd_start;
    var tbd_end = event.tbd_end;

    var all_day = event.all_day;
    
    if(tbd_start == 't' || tbd_start == true || all_day) time_start = "12:00 am";
    if(tbd_end == 't' || tbd_end == true || all_day) time_end = "11:59 pm";

    error_msg += Calendar.eventTimeErrorCheck(error_msg, time_start, time_end, date_start, date_end, "Start Time", "End Time");

    if(error_msg.length > 0 && error_msg.length > error_msg_length) {
      error_msg_length = error_msg.length;
    }

    var time_setup = '';
    var time_breakdown = '';

    if(typeof event.time_setup != 'undefined' && event.time_setup != null) {
      time_setup = event.time_setup;
    }

    if(typeof event.time_breakdown != 'undefined' && event.time_breakdown != null) {
      time_breakdown = event.time_breakdown;
    }

    if(time_setup.length > 0 || time_breakdown.length > 0) {
      error_msg += Calendar.eventTimeErrorCheck(error_msg, time_setup, time_breakdown, date_start, date_end, "Setup Time", "Breakdown Time");

      if(error_msg.length > 0 && error_msg.length > error_msg_length) {
        error_msg_length = error_msg.length;
      }
    }

    if(time_setup.length > 0 && time_breakdown.length > 0 && error_msg.length == 0) {

        var time_start_timestamp = Calendar.getTimeTimestamp(time_start, date_start);
        var time_end_timestamp = Calendar.getTimeTimestamp(time_end, date_end);

        var time_setup_timestamp = Calendar.getTimeTimestamp(time_setup, date_start);
        var time_breakdown_timestamp = Calendar.getTimeTimestamp(time_breakdown, date_end);

        if(time_setup_timestamp >= time_start_timestamp) {
            //error_msg += "Your setup time must be before your start time<br />";
            time_setup = '';
        }

        if(time_breakdown_timestamp <= time_end_timestamp) {
            //error_msg += "Your breakdown time must be after your end time<br />";
            time_breakdown = '';
        }

        if(error_msg.length > 0 && error_msg.length > error_msg_length) {
          error_msg_length = error_msg.length;
        }
    }

    if(error_msg.length > 0) {
      return null;
    }

    var process_event_conflicts = {};
    var num_event_conflicts = {};

    var dates_to_show = [];

    var date_start_formatted = Calendar.dateFormat('%Y-%m-%d', date_start_timestamp );
    var date_end_formatted = Calendar.dateFormat('%Y-%m-%d', date_end_timestamp );

    var date_duration = date_end_timestamp - date_start_timestamp;

    dates_to_show.push({
      date_start: date_start_formatted,
      date_end: date_end_formatted
    });

    if(conflicts != null) {

      for(var i in conflicts) {

        var conflict_data = conflicts[ i ];
        var conflict_type = conflict_data['title'];

        if(conflict_type != 'hash' && conflict_type != 'metadata' && conflict_type != 'metadata_by_key') {

          if(conflict_type == 'Facility') var icon_section = 'place';
          else if(conflict_type == 'Group') var icon_section = 'group';
          else if(conflict_type == 'Equipment') var icon_section = 'equipment';
          else var icon_section = null

          var icon = '<img src="' + window.EXPANDED_APP_ROOT + '../images/new_ui/' + icon_section + '_10px_gray.png" srcset="' + window.EXPANDED_APP_ROOT + '../images/new_ui/' + icon_section + '_10px_gray.png 1x, ' + window.EXPANDED_APP_ROOT + '../images/new_ui/' + icon_section + '_20px_gray.png 2x" alt="" />';
          var event_icon = '<img src="' + window.EXPANDED_APP_ROOT + '../images/new_ui/calendar2_10px_gray.png" srcset="' + window.EXPANDED_APP_ROOT + '../images/new_ui/calendar2_10px_gray.png 1x, ' + window.EXPANDED_APP_ROOT + '../images/new_ui/calendar2_20px_gray.png 2x" alt="" />';
          //icon = icons::section(icon_section, 10, alt_text='', gray=TRUE, style=NULL, mask=FALSE, class=NULL, url_only=FALSE, extra='');

          if( typeof conflict_data['objects'] != 'undefined' ) {

            for(var key_obj_id in conflict_data['objects']) {

              var value_obj = conflict_data['objects'][ key_obj_id ];

              if(typeof value_obj['host_id'] != 'undefined') {
                var event_host_id = value_obj['host_id'];
              }
              else {
                var event_host_id = 0;
              }

              var obj_id = value_obj['id'];

              var equipment_quantities = false;

              if(icon_section == 'equipment') {

                if(typeof value_obj['conflict_range_date_time_end'] != 'undefined') {
                  equipment_quantities = true;

                  var equipment_id = value_obj['id'];
                  var equipment_name = value_obj['name'];

                  var full_equipment_key = event_host_id + '_' + equipment_id;

                  var conflict_range = value_obj['conflict_range'];
                  var conflict_quantity = value_obj['conflict_quantity'];

                  var key_event_date_start = value_obj['conflict_range_date_time_start'];
                  var key_event_date_end = value_obj['conflict_range_date_time_end'];

                  if(key_event_date_end.length == 0) key_event_date_end = key_event_date_start;

                  var key_event_date_time_start_timestamp = Calendar.getDateTimeTimestamp(key_event_date_start);
                  var key_event_date_time_end_timestamp = Calendar.getDateTimeTimestamp(key_event_date_end);

                  //value_obj['name'] += '<br />' + conflict_quantity;

                  value_obj['date_start'] = Calendar.dateFormat('%Y-%m-%d', key_event_date_time_start_timestamp);
                  value_obj['date_end'] = Calendar.dateFormat('%Y-%m-%d', key_event_date_time_end_timestamp);

                  value_obj['time_start'] = Calendar.dateFormat('%l:%M %p', key_event_date_time_start_timestamp);
                  value_obj['time_end'] = Calendar.dateFormat('%l:%M %p', key_event_date_time_end_timestamp);

                  full_equipment_key += '_' + key_event_date_time_start_timestamp + '_' + key_event_date_time_end_timestamp;

                  var key_event_date_start_timestamp = Calendar.getDateTimestamp(key_event_date_start);
                  var key_event_date_end_timestamp = Calendar.getDateTimestamp(key_event_date_end);

                  if(key_event_date_start_timestamp <= date_end_timestamp && key_event_date_end_timestamp >= date_start_timestamp) {

                    key_event_date_start_timestamp = date_start_timestamp;
                    key_event_date_end_timestamp = date_end_timestamp;
                  }
                  else {

                    var key_event_date_duration = key_event_date_end_timestamp - key_event_date_start_timestamp;

                    if(key_event_date_duration != date_duration) {
                      key_event_date_end_timestamp = key_event_date_start_timestamp + date_duration;
                    }
                  }

                  key_event_date_start = Calendar.dateFormat('%Y-%m-%d', key_event_date_start_timestamp );
                  key_event_date_end = Calendar.dateFormat('%Y-%m-%d', key_event_date_end_timestamp );

                  if(typeof process_event_conflicts[ key_event_date_start ] == 'undefined') {

                    process_event_conflicts[ key_event_date_start ] = {};

                    num_event_conflicts[ key_event_date_start ] = 0;

                    if(key_event_date_start != date_start_formatted) {
                      dates_to_show.push({
                              date_start: key_event_date_start,
                              date_end: key_event_date_end
                      });
                    }
                  }

                  if(typeof process_event_conflicts[ key_event_date_start ][ full_equipment_key ] == 'undefined') {

                    process_event_conflicts[ key_event_date_start ][ full_equipment_key ] = value_obj;
                    process_event_conflicts[ key_event_date_start ][ full_equipment_key ]['host_id'] = event_host_id;
                    process_event_conflicts[ key_event_date_start ][ full_equipment_key ]['objects'] = [];

                    num_event_conflicts[ key_event_date_start ]++;
                  }

                  for(var key_event in value_obj['events']) {

                    var value_event = value_obj['events'][ key_event ];

                    //var key_event_id = value_event['id'];

                    process_event_conflicts[ key_event_date_start ][ full_equipment_key ]['objects'].push(event_icon + value_event['name']);
                  }
                }
              }

              if(!equipment_quantities) {
                if( typeof value_obj['events'] != 'undefined' ) {
                  for(var key_event in value_obj['events']) {

                    var value_event = value_obj['events'][ key_event ];

                    var key_event_id = value_event['id'];
                    var key_event_date_start = value_event['conflict_range_date_time_start'];
                    var key_event_date_end = value_event['conflict_range_date_time_end'];

                    if(key_event_date_end.length == 0) key_event_date_end = key_event_date_start;

                    var key_event_date_start_timestamp = Calendar.getDateTimestamp(key_event_date_start);
                    var key_event_date_end_timestamp = Calendar.getDateTimestamp(key_event_date_end);

                    if(key_event_date_start_timestamp <= date_end_timestamp && key_event_date_end_timestamp >= date_start_timestamp) {

                      key_event_date_start_timestamp = date_start_timestamp;
                      key_event_date_end_timestamp = date_end_timestamp;
                    }
                    else {

                      var key_event_date_duration = key_event_date_end_timestamp - key_event_date_start_timestamp;

                      if(key_event_date_duration != date_duration) {
                        key_event_date_end_timestamp = key_event_date_start_timestamp + date_duration;
                      }
                    }

                    key_event_date_start = Calendar.dateFormat('%Y-%m-%d', key_event_date_start_timestamp );
                    key_event_date_end = Calendar.dateFormat('%Y-%m-%d', key_event_date_end_timestamp );

                    if(typeof process_event_conflicts[ key_event_date_start ] == 'undefined') {

                      process_event_conflicts[ key_event_date_start ] = {};

                      num_event_conflicts[ key_event_date_start ] = 0;

                      if(key_event_date_start != date_start_formatted) {

                        dates_to_show.push({
                          date_start: key_event_date_start,
                          date_end: key_event_date_end
                        });
                      }
                    }

                    var full_event_key = event_host_id + '_' + key_event_id;

                    if(typeof process_event_conflicts[ key_event_date_start ][ full_event_key ] == 'undefined') {

                      process_event_conflicts[ key_event_date_start ][ full_event_key ] = value_event;
                      process_event_conflicts[ key_event_date_start ][ full_event_key ]['host_id'] = event_host_id;
                      process_event_conflicts[ key_event_date_start ][ full_event_key ]['objects'] = [];

                      num_event_conflicts[ key_event_date_start ]++;
                    }

                    process_event_conflicts[ key_event_date_start ][ full_event_key ]['objects'].push(icon + value_obj['name']);
                  }
                }
              }
            }
          }
        }
      }
    }

    dates_to_show.sort( function(a, b)
      {
        return a.date_start.localeCompare(b.date_start);
      }
    );
    
    let event_bubble_html = [];

    for(var i in dates_to_show)
    {
      var date_to_show = dates_to_show[i];

      date_start = date_to_show.date_start;
      date_end = date_to_show.date_end;

      var event_bubble_event_time_start_style = '';
      var event_bubble_event_time_breakdown_style = '';

      var event_bubble_event_style = '';

      var time_range_lines = 0;

      if(time_start.length > 0 && time_end.length > 0) {

        if(date_start.length == 0) date_start = '01/01/1975';
        if(date_end.length == 0) date_end = date_start;

        if(time_setup.length > 0) {
          var time_range_start = time_setup;
        }
        else {
          var time_range_start = time_start;
        }

        if(time_breakdown.length > 0) {
          var time_range_end = time_breakdown;
        }
        else {
          var time_range_end = time_end;
        }

        var time_range_start_minutes_orig = Calendar.getMinutesFromTime(date_start, '12:00 am', date_start, time_range_start);
        var time_range_end_minutes_orig = Calendar.getMinutesFromTime(date_start, '12:00 am', date_end, time_range_end);

        var elapsed_minutes_orig = time_range_end_minutes_orig - time_range_start_minutes_orig;

        if(elapsed_minutes_orig < 2) {
          var line_minutes = 1;
        }
        else if(elapsed_minutes_orig < 5) {
          var line_minutes = 2;
        }
        else if(elapsed_minutes_orig < 15) {
          var line_minutes = 5;
        }
        else if(elapsed_minutes_orig < 30) {
          var line_minutes = 15;
        }
        else if(elapsed_minutes_orig <= 540) {
          var line_minutes = 30;
        }
        else if(elapsed_minutes_orig <= 2880) {
          var line_minutes = 60;
        }
        else if(elapsed_minutes_orig <= 10080) {
          var line_minutes = 120;
        }
        else {
          var line_minutes = 240;
        }

        var time_start_offset = (time_range_start_minutes_orig % line_minutes);
        var time_end_offset = (time_range_end_minutes_orig % line_minutes);

        var time_range_start_minutes = time_range_start_minutes_orig - line_minutes;
        var time_range_end_minutes = time_range_end_minutes_orig + line_minutes;

        var start_minute_offset = line_minutes;

        if(time_start_offset > 0) {

          time_range_start_minutes -= time_start_offset;
          start_minute_offset += time_start_offset;
        }

        if(time_end_offset > 0) {
          time_range_end_minutes += (line_minutes - time_end_offset);
        }

        // var time_range_start_obj = new get_hour_minute_from_minutes(time_range_start_minutes);
        // var time_range_end_obj = new get_hour_minute_from_minutes(time_range_end_minutes);

        // var time_range_start_hour = time_range_start_obj.hour;
        // var time_range_start_minute = time_range_start_obj.minute;

        // var time_range_end_hour = time_range_end_obj.hour;
        // var time_range_end_minute = time_range_end_obj.minute;

        var time_range_elapsed_minutes = time_range_end_minutes - time_range_start_minutes;

        time_range_lines = time_range_elapsed_minutes / line_minutes;
        var time_range_sections = time_range_elapsed_minutes / (line_minutes * 2);

        if(time_range_lines <= 3) {
          var event_bubble_size = 'xxlarge';
          var line_size = 46;
        }
        else if(time_range_lines <= 4) {
          var event_bubble_size = 'xlarge';
          var line_size = 40;
        }
        else if(time_range_lines <= 6) {
          var event_bubble_size = 'large';
          var line_size = 34;
        }
        else if(time_range_lines <= 9) {
          var event_bubble_size = 'medium';
          var line_size = 28;
        }
        else if(time_range_lines <= 12) {
          var event_bubble_size = 'standard';
          var line_size = 22;
        }
        else {
          var event_bubble_size = 'small';
          var line_size = 16;
        }

        var pixel_per_minute = line_size / line_minutes;
      }

      let conflict_header;
      let event_bubbles = [];

      if(time_range_lines > 0) {

        if(dates_to_show.length > 1) {

          if(typeof process_event_conflicts[ date_start ] != 'undefined') {
            conflict_header = <div key={`event_bubble_${date_start}_date_header`} className="date_header">{`Conflicts for events that start on ${Calendar.dateFormat('(%a) %b %e%o, %Y', Calendar.getDateTimestamp(date_start) )}`}</div>;
          } else {
            conflict_header = <div key={`event_bubble_${date_start}_date_header`} className="date_header">{`${Calendar.dateFormat('(%a) %b %e%o, %Y', Calendar.getDateTimestamp(date_start) )}`}</div>;
          }
        }

        var time_range_start_timestamp_obj = new Date();
        time_range_start_timestamp_obj.setTime( Calendar.getTimeTimestamp('12:00 am', date_start) );
        
        var time_range_start_timestamp = time_range_start_timestamp_obj.getTime();

        time_range_start_timestamp += (time_range_start_minutes * 60000);

        time_range_start_timestamp_obj.setTime(time_range_start_timestamp);

        var time_range_end_timestamp_obj = new Date();
        time_range_end_timestamp_obj.setTime( Calendar.getTimeTimestamp('12:00 am', date_start) );
        
        var time_range_end_timestamp = time_range_end_timestamp_obj.getTime();

        time_range_end_timestamp += (time_range_end_minutes * 60000);

        time_range_end_timestamp_obj.setTime(time_range_end_timestamp);

        var num_event = 1;

        if(typeof process_event_conflicts[ date_start ] != 'undefined') {

          var width_to_work_with = 197;

          var overlap = 0.9;

          var custom_width = (width_to_work_with / ((num_event_conflicts[ date_start ] + 1) * overlap)) - 24;

          while(custom_width < 30 && overlap > 0.09) {
              overlap -= 0.1;

              var custom_width = (width_to_work_with / ((num_event_conflicts[ date_start ] + 1) * overlap)) - 24;
          }

          var custom_offset = (width_to_work_with - custom_width - 24) / num_event_conflicts[ date_start ];
        }
        else {

          var custom_width = null;
          var custom_offset = null;
        }

        event_bubbles.push( this.bubble(time_range_start_timestamp, time_range_end_timestamp, pixel_per_minute, num_event, 'normal', name, date_start, date_end, time_start, time_end, time_setup, time_breakdown, null, null, custom_width) );

        num_event++;

        if(typeof process_event_conflicts[ date_start ] != 'undefined') {

          for(var i in process_event_conflicts[ date_start ]) {

            var conflicting_event = process_event_conflicts[ date_start ][ i ];

            event_bubbles.push( this.bubble(time_range_start_timestamp, time_range_end_timestamp, pixel_per_minute, num_event, 'conflicted', conflicting_event['name'], conflicting_event['date_start'], conflicting_event['date_end'], conflicting_event['time_start'], conflicting_event['time_end'], '', '', conflicting_event['objects'], custom_offset, custom_width) );

            num_event++;
          }
        }

        var time_range_section_prev_date = time_range_start_timestamp_obj.getDate();

        if(time_range_start_minutes < 0) time_range_start_minutes = 1440 + time_range_start_minutes;

        let line_class = ((time_range_start_minutes % (2 * line_minutes)) < line_minutes) ? 'start' : 'end';

        if(line_class == 'start' && ((time_range_lines % 2) == 0)) time_range_sections++;

        var time_range_section_timestamp = new Date();

        let times = [];

        for(var i = 0; i < time_range_sections; i++) {

          var minutes_to_add = (line_minutes * 2 * i);

          if(line_class == 'end') {

            minutes_to_add += line_minutes;
          }

          time_range_section_timestamp.setTime(time_range_start_timestamp + (minutes_to_add * 60000));

          var time_range_section_date = time_range_section_timestamp.getDate();

          if(time_range_section_date != time_range_section_prev_date && i < (time_range_sections - 1) && i > 0) {

            var time_range_section_type = 'date';
            var time_range_section_data = (<strong>{`${time_range_section_timestamp.getMonthName()} ${time_range_section_date}${time_range_section_timestamp.dayNumSuffix()}`}</strong>);
          }
          else {

            var time_range_section_type = 'time';

            var hour = time_range_section_timestamp.getHours();
            var minute = time_range_section_timestamp.getMinutes();

            if(hour >= 12 && hour <= 23) var ampm = 'pm';
            else var ampm = 'am';

            if(hour > 12) hour -= 12;
            else if(hour == 0) hour = 12;

            if(minute < 10) {
              minute = '0' + minute.toString();
            }

            var time_range_section_data = hour + ':' + minute + ampm;
          }

          time_range_section_prev_date = time_range_section_date;

          if(i == 0)
          {
            if(line_class == 'end') {

              times.push( <div key={`event_bubble_${date_start}_time_empty`} className="time empty">{'\u00a0'}</div> );
            }
            else {

              times.push( <div key={`event_bubble_${date_start}_time_empty`} className="time blank">{'\u00a0'}</div> );
            }
          }

          times.push( <div key={`event_bubble_${date_start}_time_${i}`} className="time">{time_range_section_data}</div> );
        }

        let lines = [];

        for(var i = 0; i < time_range_lines; i++) {

          lines.push( <div key={`event_bubble_${date_start}_line_${i}`} className={`line ${line_class}`}>{'\u00a0'}</div> );

          line_class = (line_class == 'start') ? 'end' : 'start';
        }

        event_bubble_html.push(
          <div key={`event_bubble_${date_start}`} className={`event_bubble ${event_bubble_size}`}>
            {conflict_header}
            {event_bubbles}
            <div key={`event_bubble_${date_start}_times_and_lines`} className="times_and_lines">
              <div key={`event_bubble_${date_start}_times_and_lines_row`} className="times_and_lines_row">
                <div key={`event_bubble_${date_start}_times`} className="times">
                  {times}
                </div>
                <div key={`event_bubble_${date_start}_lines`} className="lines">
                  {lines}
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    return (
      <div key="event_bubbles" className="event_bubbles">
        {event_bubble_html}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  //const { } = state;
  const { event } = ownProps;
  let { conflicts } = ownProps;

  let isLoaded = false;

  if(event.date_start.length > 0 && (((event.time_start.length > 0 || event.tbd_start == 't' || event.tbd_start == true) && (event.time_end.length > 0 || event.tbd_end == 't' || event.tbd_end == true)) || event.all_day)) {
    isLoaded = true;
  }

  if(typeof conflicts == 'undefined' && typeof event.conflicts != 'undefined') {
    conflicts = event.conflicts;
  }

  if (has(conflicts, 'conflicts')) {
    conflicts = conflicts.conflicts;
  }

  return {
    isLoaded,
    event,
    conflicts
  };
}

export default connect(mapStateToProps, {
  //getSearchData,
})(EventBubble);



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventBubble.js